import React, { useState } from 'react';
import { toast } from 'sonner';
import { BookOpen, Loader2, RefreshCw } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { runAiJob } from '../../lib/aiJob';

const RESP = { respaldada: ['Respaldada por fallos', 'text-emerald-300'], discutida: ['Discutida en fallos', 'text-amber-300'], sin_fallos: ['Sin fallos aún', 'text-slate-400'], sin_doctrina: ['Sin doctrina citable', 'text-slate-500'] };
const REL = { coincide: 'text-emerald-300', se_aparta: 'text-rose-300', matiza: 'text-amber-300' };

// Doctrina en la causa: applicable doctrine topics and whether case law backs them (computed automatically)
export const MatterDoctrine = ({ matter, onUpdated }) => {
  const { api, user } = useAuth();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const a = matter.doctrine_analysis;
  const run = async () => {
    setBusy(true);
    try { await runAiJob(api, `/doctrine/matters/${matter.id}/analyze`, {}, { timeout: 240000 }); onUpdated(); setOpen(true); } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  if (matter.country && matter.country !== 'chile') return null;
  return (
    <div data-testid={`matter-doctrine-${matter.id}`} className="mt-2">
      <div className="flex flex-wrap items-center gap-2">
        <button data-testid={`matter-doctrine-toggle-${matter.id}`} onClick={() => (a ? setOpen((v) => !v) : matter.user_id === user?.id && run())} disabled={busy || (!a && matter.user_id !== user?.id)} className="flex items-center gap-1.5 rounded-full border border-sky-500/40 px-3 py-1 text-xs text-sky-200 disabled:opacity-60">
          {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <BookOpen className="h-3 w-3" />}
          {a ? `Doctrina aplicable · ${a.temas.length} tema(s)` : busy ? 'Fidem analiza la doctrina...' : 'Doctrina aplicable (calculando)'}
        </button>
        {a && matter.user_id === user?.id && <button data-testid={`matter-doctrine-refresh-${matter.id}`} onClick={run} disabled={busy} aria-label="Actualizar" className="text-slate-500 hover:text-sky-300"><RefreshCw className={`h-3 w-3 ${busy ? 'animate-spin' : ''}`} /></button>}
      </div>
      {open && a && (
        <div className="mt-2 max-h-80 space-y-2 overflow-y-auto pr-1">
          {!a.temas.length && <p className="text-xs text-slate-500">Esta causa no involucra temas de derecho notarial o registral.</p>}
          {a.temas.map((t) => (
            <div key={t.key} data-testid={`matter-doctrine-topic-${t.key}`} className="rounded-xl border border-slate-700 bg-slate-950/40 p-3 text-xs">
              <p className="font-semibold text-white">{t.label} · <span className={RESP[t.respaldo]?.[1]}>{RESP[t.respaldo]?.[0] || t.respaldo}</span></p>
              {t.doctrina.map((x, i) => <p key={i} className="mt-1 text-slate-300"><b>{x.autor}</b>, «{x.obra}», p. {x.pagina}: {x.postura}</p>)}
              {t.fallos.map((f) => <p key={f.id} className={`mt-1 ${REL[f.relacion] || 'text-slate-300'}`}>{f.relacion?.replace('_', ' ')} · {f.titulo} ({f.tribunal}): <span className="text-slate-300">{f.explicacion}</span></p>)}
              {t.como_usarlo && <p className="mt-1 text-slate-400"><b>Cómo usarlo:</b> {t.como_usarlo}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
